import React from "react";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
} from "react-google-maps";

const BoundsOnChangeMap = withScriptjs(
  withGoogleMap(props => {
    /* Defaults */
    const zoom = props.defaultZoom || 6;
    let center = { lat: 41.89193, lng: 12.51133 };
    if (props.defaultCenter &&
      typeof props.defaultCenter.lat == "number" &&
      typeof props.defaultCenter.lng == "number"
    ) {
      center = props.defaultCenter;
    }
    /* /Defaults */
    return (
        <GoogleMap
          // mapTypeId={"satellite"}
          center={center}
          zoom={zoom}
          defaultOptions={{
            scrollwheel: true
          }}
          ref={props.handleMapMounted}
          onDragEnd={props.onDragEnd}
          onZoomChanged={props.onZoomChanged}
        >
        </GoogleMap>
    );
  })
);

export default BoundsOnChangeMap;


// WEBPACK FOOTER //
// ./src/views/Projects/BoundsOnChangeMap.jsx